export default function (blob) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      // The result can't be directly decoded as base64.
      // We need to strip off the first part. See note at:
      // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
      const base64Part = reader.result.split(',')[1]
      resolve(base64Part)
    }

    reader.readAsDataURL(blob)
  })
}
